<template>
  <div>
    <b-alert show variant="light" class="small">
      Adquisición y retorno de inversión. La captura de <strong>inversión de marketing</strong>
      y metas se administra en <b-link @click="$router.push('/marketing/attribution')">Marketing → Atribución</b-link>.
    </b-alert>
    <!-- Reporte 12 · Finanzas / ROI-ROAS (vista de marketing) -->
    <exec-report-panel report-name="finance" title="ROI / ROAS por campaña" :filters="filters" @error="$emit('error', $event)" />
    <!-- Reporte 3 · Embudo -->
    <div class="mt-4">
      <exec-report-panel report-name="funnel" title="Embudo de adquisición" :filters="filters" @error="$emit('error', $event)" />
    </div>
  </div>
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 7 · Marketing y adquisición (doc 04 §3, reportes 3, 4 y 12 + captura spend).
export default { name: 'ExecMarketing', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
